import React from "react";
import { Text, TextProps } from "@chakra-ui/react";

export const Note = ({ children, ...props }: TextProps) => (
    <Text fontSize={"1.2rem"} lineHeight={"1.6rem"} fontWeight={props.fontWeight ?? "normal"} {...props}>
        {children}
    </Text>
);
